import { h, PropType, defineComponent } from 'vue';
import { coming_soon } from '@components/icons';
import { State } from '../../state';
import BarButton from '@components/bar-button';
import show_grid_size_svg from '../../../assets/img/SVG_icons/Bottom/visualisation/set_grid_size.svg';
import { img } from '@phi/components';
import { display_show_set_gridsize_modal } from '@frontend/ui_display';
import ShowGridsizeModalTooltip from './ShowGridsizeModalTooltip';
import { ISubscriptions } from '@phi/subscriptions/frontend';

export const ShowGridSizeIcon = show_grid_size_svg;

export default defineComponent({
    props: {
        state: {
            required: true,
            type: Object as PropType<State>,
        },
        subscriptions: { required: true, type: Object as PropType<ISubscriptions> },
    },

    computed: {
        coming_soon() {
            return !this.state.loaded;
        },

        alt() {
            return 'Set grid spacing';
        },

        disabled() {
            return !this.state.loaded;
        }
    },

    watch: {
        disabled(value: boolean) {
            this.$emit('update:disabled', value);
        },
    },

    emits: {
        'update:disabled': (x: boolean) => true,
    },

    methods: {
        onClick() {
            if (this.disabled)
                return;
            else if (this.subscriptions.state.subscription_status.value === 'starter')
                this.subscriptions.show_pro_feature_modal();
            else
                display_show_set_gridsize_modal();
        },
    },

    render() {
        return h(BarButton, {
            id: 'show-gridsize-modal-button',
            tippy: 'top',
            disabled: this.disabled,
            active: false,
            selected: this.state.tut_stage === 3,
            onClick: this.onClick,
            pro_indicator: this.subscriptions.state.subscription_status.value === 'starter',
        }, {
            icon: () => this.coming_soon ? coming_soon(this.alt) : img(show_grid_size_svg, this.alt),
            tooltip: ShowGridsizeModalTooltip,
        });
    },
});
